import React from 'react';
import { motion } from 'framer-motion';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
}
export function FeatureCard({
  icon,
  title,
  description,
  delay = 0
}: FeatureCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-navy-800/50 border border-navy-800 rounded-2xl p-6 sm:p-8 relative overflow-hidden group hover:border-navy-800/80 transition-colors" data-id="element-15">
      {/* Subtle glow behind icon */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-cyan-500/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 group-hover:bg-cyan-500/20 transition-colors" data-id="element-16" />

      <div className="relative z-10" data-id="element-17">
        <div className="w-12 h-12 rounded-xl bg-navy-900 border border-navy-800 flex items-center justify-center text-cyan-400 mb-6 shadow-[0_0_15px_rgba(6,182,212,0.15)]" data-id="element-18">
          {icon}
        </div>
        <h3 className="font-heading text-2xl text-white mb-3" data-id="element-19">
          <span className="text-amber-400 mr-2" data-id="element-20">/</span>
          {title}
        </h3>
        <p className="text-slate-300 leading-relaxed font-body" data-id="element-21">
          {description}
        </p>
      </div>
    </motion.div>;
}